module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><path d=\"M10 5L8 3H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-5z\" fill=\"#F6A623\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/List/icon-folder-active.svg
// module id = 215
// module chunks = 0